import React, { Component } from 'react';
import './ExitScreen.css';
import { withTranslation } from "react-i18next";
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';

class ExitScreen extends Component {

    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        const callback_url = urlParams.get('callback_url');
        this.state = { callback_url: null };
        if (callback_url !== null) {
            this.state = { callback_url };
            setTimeout(function () {
                window.location.replace(callback_url);
            }, 5000);

        }
    }




    render() {
        const { t } = this.props;
        return (
            <Box className="ExitScreen" >
                <Alert variant="filled" severity="success" sx={{ mx: "10px" }}>
                    {t('Dziękujemy za wideoweryfikację.')}
                </Alert>
                <div style={{ textAlign: 'center', opacity: 0.7 }}>
                    <CheckCircleOutlineIcon className='succesIcon' color='success' sx={{ fontSize: { xs: "15rem", sm: "30rem" } }} />
                </div>
                <Typography variant="h1" component="div" gutterBottom sx={{ color: '#2e7d32', mt: '20px', textAlign: 'center', fontSize: { xs: "5rem", sm: "6rem" } }}>
                    {t("KONIEC")}
                </Typography>
                {this.state.callback_url && <p>{t('Za chwilę nastąpi przekierowanie...')}<div className="spinner-border" role="status"></div></p>}
                {this.state.callback_url && <p>{t('W przeciwnym przypadku kliknij')} <a href={this.state.callback_url}>{this.state.callback_url}</a></p>}
            </Box>
        );
    }
}

export default withTranslation()(ExitScreen);